import React from 'react'
import Appbar from 'components/Appbar'
import TableView from './TableView'
import BuildingSearch from './BuildingSearch'
import { PageContent, ModalLayer } from '@ui'
import { Router, RouteComponentProps } from '@reach/router'
import { navigateWithBasepath } from '../../App'
import useBuildings from './hooks/useBuildings'
import { useReload } from '@hooks/reloadContext'

export default function BuildingManager({ navigate }: RouteComponentProps) {
  const buildings = useBuildings()
  const reload = useReload()

  return (
    <>
      {/* eslint-disable @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Router primary={false} navigate={navigateWithBasepath}>
        <ModalLayer path="*" reload={reload.buildings} />
      </Router>
      <Appbar title="Buildings and Floors">
        <BuildingSearch
          navigate={navigate}
          queryTable={(query: string) => {
            buildings.applyFilters({ ...buildings.filters, query })
          }}
          includeOld={buildings.filters.includeOld}
        />
      </Appbar>
      <PageContent>
        <TableView navigate={navigate} buildings={buildings} />
      </PageContent>
    </>
  )
}
